import { UserIndexRouteView } from './view';

export const indexRoute = {
  index: true,
  element: <UserIndexRouteView/>,
};